export enum CompanyDrawerTabs {
  OVERVIEW = 'overview',
  REQUESTS = 'requests',
  ASSESSMENT = 'assessment',
  AFFILIATED_THIRD_PARTIES = 'affiliated-third-parties',
  ALERTS = 'alerts',
  ARTIFACTS = 'artifacts',
  USAGE = 'usage',
  PERMISSIONS = 'permissions',
  ASSETS = 'assets',
  FOURTH_PARTIES = 'fourth-parties',
}
